import $ from 'jquery';
import 'slick-carousel/slick/slick';
import '../../../source/scripts/scrollUp.js';
import { lazyLoadJavascripts } from '../../../source/scripts/helpers/lazy';
import { accordion } from '../../../source/modules/containers/accordion/index';

const OPEN = 'is-open';
const NO_SCROLL = 'no-scroll';

$(document).ready(() => {
  const burger = $('.js-burger');
  const menuItem = $('.menu__item--has-child');
  const body = $('body');
  const mobileMenu = $('.menu');

  burger.click(() => {
    burger.toggleClass(OPEN);
    mobileMenu.toggleClass(OPEN);
    body.toggleClass(NO_SCROLL);
  });

  menuItem.click(() => {
    menuItem.toggleClass(OPEN);
  });

  accordion();
});

window.$ = $;
window.lazyLoadJavascripts = lazyLoadJavascripts;
